import React, { useMemo } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { getPolyglot } from '../../../i18n';
import StoerkIdAPI from '../../../redux/stoerkID/StoerkIdAPI';
import useParseErrorMessage from '../../../handlingErrors/useParseErrorMessage';
import { useAppSelector } from '../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../redux/stoerkID/selectors/StoerkId.selectors';
import { Link as LinkRouter } from 'react-router-dom';
import OrganizationTable from './OrganizationTable';

function OrganizationListPage() {
  const polyglot = getPolyglot();
  const parseErrorMessage = useParseErrorMessage();
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const {
    data: subWorkspaces,
    isLoading,
    isError,
    error,
  } = StoerkIdAPI.useGetSubWorkspacesQuery(myWorkspace?.id ?? '', {
    skip: !myWorkspace?.id,
  });

  const childIds = useMemo(
    () => (subWorkspaces ? Object.keys(subWorkspaces) : []),
    [subWorkspaces]
  );

  return (
    <Container
      maxWidth="xl"
      sx={{
        padding: 3,
        paddingBottom: 2,
      }}
      disableGutters
    >
      <Box mb={1}>
        <Typography variant="h1">
          {polyglot.t('stoerk_id.organization_list.title')}
        </Typography>
        <Typography>
          {polyglot.t('stoerk_id.organization_list.note')}
        </Typography>
      </Box>

      <Box display="flex" gap={2} mb={2}>
        <Button
          component={LinkRouter}
          to="/account/my-account"
          variant="contained"
        >
          {polyglot.t('stoerk_id.organization_list.view_my_cloud_account')}
        </Button>
        <Button
          component={LinkRouter}
          to="/account/organizations/create"
          variant="contained"
          color="primary"
        >
          {polyglot.t('stoerk_id.organization_list.add_new_cca')}
        </Button>
      </Box>

      {isLoading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100px"
        >
          <CircularProgress />
        </Box>
      )}

      {isError && <Alert severity="error">{parseErrorMessage(error)}</Alert>}

      {!isLoading && !isError && (
        <OrganizationTable
          childIds={childIds}
          parentWorkspaceId={myWorkspace?.id ?? ''}
        />
      )}
    </Container>
  );
}

export default OrganizationListPage;
